<template>
  <section class="userset-cont">
    <div class="contacts-tree">
      <!-- 通讯录树形结构 -->
      <el-tree :data="contactData" :props="defaultProps" node-key="depId" @node-click="handleNodeClick"
        :expand-on-click-node="false" :default-expanded-keys="[1]"></el-tree>
    </div>
    <contacts></contacts>
  </section>
</template>
<script>
  import Contacts from '@/page/main/contacts'

  import {
    mapState
  } from "vuex";
  export default {
    computed: {
      ...mapState({
        contactCurNode: state => state.main.contactCurNode,
        contactSelectArr: state => state.main.contactSelectArr,
        contactSingleSelect: state => state.main.contactSingleSelect,

        organization: state => state.main.organization,
        employeeList: state => state.main.employeeList,
      })
    },
    data() {
      return {
        searchKey: "",

        // 导航
        contactData: [],
        defaultProps: {
          children: 'childDepts',
          label: 'name'
        },

        // 列表
        loading: true,
        listData: [],
        filterData: [],
        // 已选择的人员数组
        selectArr: [],
        checkboxArr: [],

        tableKey: new Date().getTime(),
      }
    },
    mounted() {
      this.selectArr = this.contactSelectArr
      this.getContactsList()
      // this.getLists()
      // 选上默认的项目
      for (var i = 0; i < this.selectArr.length; i++) {
        this.checkboxArr[this.selectArr[i].id] = true
      }
    },
    components: {
      Contacts,
    },
    methods: {
      successSelect() {
        this.$store.commit('set_contactSelectArr', this.selectArr)
        this.setContactHide()
      },
      // 选中checkbox事件
      selectedChange(row) {
        let _has = false
        let _index
        for (var i = 0; i < this.selectArr.length; i++) {
          var _item = this.selectArr[i]
          if (row.id == _item.id) {
            _index = i
            _has = true
          }
        }
        if (_has) {
          this.selectArr.splice(_index, 1);
          this.checkboxArr[row.id] = false
        } else {
          this.selectArr.push(row)
          this.checkboxArr[row.id] = true
          if (this.contactSingleSelect) {
            this.$store.commit('set_contactSelectArr', this.selectArr)
            this.setContactHide()
          }
        }
      },
      // 是否选中
      isSelected(row) {
        console.log(this.selectArr.indexOf(row))
        return this.selectArr.indexOf(row) == -1 ? false : true
      },
      // 隐藏人物选择弹窗
      setContactHide() {
        this.$store.commit('set_contactShow', false)
        this.$store.commit("set_contactCurNode", {})
      },
      // 获取组织架构列表
      getContactsList() {
        if (this.organization.length > 0) {
          this.contactData = this.organization
        } else {
          ajax.get('/dept/list', '', (res) => {
            this.contactData = res.vo.array
            this.$store.commit('set_organization', res.vo.array)
          })
        }
      },
      // 点击目录
      handleNodeClick(data) {
        this.$store.commit("set_contactCurNode", data)
      },
      // 搜索筛选新闻数据
      getFilterData() {
        if (this.searchKey) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _new = this.listData[i]
            if (_new.name.indexOf(this.searchKey) != -1) {
              this.filterData.push(_new)
            }
          }
        } else {
          this.filterData = this.listData
        }
      },
      // 获取列表
      getLists() {
        let _depId = ""
        if (this.contactCurNode.depId) {
          _depId = this.contactCurNode.depId
        }
        if ((_depId == "" || _depId == 1) && this.employeeList.length > 0) {
          this.$nextTick(() => {
            this.loading = false
            this.filterData = this.listData = this.employeeList
          })
        } else {
          ajax.get('/dept/role/users', {
            'deptId': _depId
          }, (res) => {
            this.loading = false
            this.filterData = this.listData = res.vo.array
            if ((_depId == "" || _depId == 1)) {
              this.$store.commit('set_employeeList', res.vo.array)
            }
          })
        }
      },
    },
    watch: {
      contactCurNode() {
        this.loading = true
        this.getLists()
        this.tableKey = new Date().getTime()
      },
      searchKey() {
        if (this.searchKey) {
          this.getFilterData()
        } else {
          this.filterData = this.listData
        }
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/set/userSet.vue